import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const MonthHeader = ({ displayMonth, getNextWeek, getPrevWeek }) => (
  <div className="month-header">
    <button className="month-header_arrow" onClick={getPrevWeek}>
      <FontAwesomeIcon className="month-header_arrow" size="2x" icon={['fal', 'chevron-left']} />
    </button>
    <span className="month-header_span">{displayMonth}</span>
    <button className="month-header_arrow" onClick={getNextWeek}>
      <FontAwesomeIcon size="2x" icon={['fal', 'chevron-right']} />
    </button>
  </div>
);

export default MonthHeader;



// WEBPACK FOOTER //
// ./src/components/WeeklyCalendar/MonthHeader.js